import classnames from 'classnames';
import sortDirection24 from 'images/icons/sort-direction-24.svg';
import React from 'react';

interface Props {
  label: string;
  id: string;
  sortField: string;
  sortDirection: 'ascending' | 'descending';
  onUpdateSort: (id: string) => void;
}

const SortPopoverItem: React.FunctionComponent<Props> = (props: Props) => {
  const { label, id, sortField, sortDirection, onUpdateSort } = props;

  const currentItem = sortField === id;

  return (
    <div
      id={`sort-popover-item-${id}`}
      className={classnames(
        'row items-center justify-between px4 bb-3 cursor-pointer',
        {
          'medium secondary-blue bgd-primary-blue-opacity-10': currentItem,
        }
      )}
      style={{ height: '44px' }}
      onClick={() => onUpdateSort(id)}
    >
      <div>{label}</div>
      {currentItem ? (
        <div>
          <img
            src={sortDirection24}
            alt={`sort popover item ${id}`}
            className={classnames({
              'rotate-180': sortDirection === 'ascending',
            })}
          />
        </div>
      ) : null}
    </div>
  );
};

export default SortPopoverItem;
